import { useEffect, useRef } from 'react';

// Raw HTML section. innerHTML never runs <script>, so scripts are re-created to execute.
export function HtmlSection({ s }) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.innerHTML = s.body || '';
    el.querySelectorAll('script').forEach((old) => {
      const sc = document.createElement('script');
      [...old.attributes].forEach((a) => sc.setAttribute(a.name, a.value));
      sc.text = old.textContent;
      old.replaceWith(sc);
    });
  }, [s.body]);
  return <section ref={ref} data-testid={`cms-section-html-${s.section_key}`} />;
}

export default HtmlSection;
